// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { Component } from './component';

/**
 * @class Jsw.Hint
 * @extends Jsw.Component
 *
 * Example usage:
 *
 *     @example
 *     new Jsw.Hint({
 *         renderTo: document.body,
 *         hint: 'This is where you manage accounts of your hosting service customers: ' +
 *             'create accounts along with service subscriptions, manage existing customers, ' +
 *             'and remove accounts. To administer websites, mail or any other services provided ' +
 *             'to a customer, go to their Customer Panel by clicking the link in the right column of the list.',
 *         expandable: true
 *     });
 */
export class Hint extends Component {
    /**
     * @cfg {String} hint
     */
    /**
     * @cfg {Boolean} [expandable=false]
     */

    _initConfiguration(config) {
        this._tag = 'p';
        super._initConfiguration(config);
    }

    _initComponentElement() {
        super._initComponentElement();

        this.setHint(
            this._getConfigParam('hint', '')
        );

        if (this._getConfigParam('expandable', false)) {
            const contentElement = this._componentElement;
            const componentElement = new Element('div', { class: 'screen-description' });
            const wrapElement = new Element('div', { class: 'screen-description-wrap' });
            const btnShowMore = new Element('span', { class: 'screen-description-control' });
            btnShowMore.observe('click', function () {
                this.up('.screen-description').addClassName('expanded');
            });
            wrapElement.insert(contentElement);
            wrapElement.insert(btnShowMore);
            this._componentElement = componentElement.update(wrapElement);
            this._screenControl = function () {
                if (componentElement.getWidth() > wrapElement.getWidth()) {
                    btnShowMore.addClassName('off');
                } else {
                    btnShowMore.removeClassName('off');
                }
            };
        }
    }

    _addEvents() {
        super._addEvents();

        if (this._screenControl) {
            Event.observe(window, 'resize', this._screenControl);
            this._screenControl();
        }
    }

    /**
     * Update hint text.
     * @param {String} hint
     */
    setHint(hint) {
        this._componentElement.update(hint);
    }
}



// WEBPACK FOOTER //
// ./jsw/hint.js